{
  "page_title": "Reset password",
  "heading": "Reset your password",
  "byline": "Please enter a new password for your account.",
  "errors": {
    "tokenMissing": "Missing reset token",
    "tokenInvalid": "Reset token is invalid or has already expired",
    "tokenExpired": "Reset token has expired",
    "tokenUsed": "This reset token has already been used",
    "tokenGenericError": "Error validating token",
    "byline": "Please return to the <1>reset password</1> screen and try again"
  },
  "inputs": {
    "password": "New password"
  },
  "buttons": {
    "submit": "Reset password"
  }
}
